module.exports = __webpack_public_path__ + "img/d-2-3.a89c3f47.png";